<template>
  <div class="dialogRule">
    <el-dialog
      :visible="isShow && tabIndex === '1'"
      :title="$t('AutomaticRelease.common.ruleTitle')"
      :close-on-click-modal="false"
      :show-close="false"
      width="600px"
    >
      <div class="app-main-inner-row">
        <div style="width:600px;">
          <el-form label-width="100px" :rules="validationRules" :model="form" @submit.native.prevent>
            <el-form-item :label="$t('AutomaticRelease.ruleName1')" class="spacing setStyle" prop="ruleName" :show-message="false" style="color: #4283ff;">
              <el-input v-model="form.ruleName" :placeholder="$t('AutomaticRelease.enterRuleName')" />
            </el-form-item>

            <el-form-item :label="$t('AutomaticRelease.ruleDescription')" class="spacing">
              <el-input v-model="form.describe" :placeholder="$t('AutomaticRelease.ruleDescriptionPlaceholder')" type="textarea" />
            </el-form-item>

            <span class="businessTypes">{{ $t('AutomaticRelease.businessTypes') }}</span>
            <el-form-item :label="$t('AutomaticRelease.ChargeRecordState')" label-width="120px" class="spacing">
              <el-select v-model="form.chargeRecordState" no="chargeRecordState">
                <el-option v-for="item in chargeRecordStates" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <span class="conditionsTitle">{{ $t('AutomaticRelease.meetAnyConditions') }}</span>

            <el-form-item label-width="0" class="spacing newColumnRule">
              <div v-for="(item, index) in rules" :key="`0${index}`" class="newColumn">
                <el-checkbox v-model="item.businessTypescheckAny" :true-label="1" :false-label="0" />
                <el-select v-model="item.anyType" :disabled="!item.businessTypescheckAny" class="selectWidth">
                  <el-option
                    v-for="(v, i) in item.filteringBased"
                    :key="`Any${i}1`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
                <el-select v-model="item.anyOperation" :disabled="!item.businessTypescheckAny" class="selectCenterWidth">
                  <el-option
                    v-for="(v, i) in item.operation"
                    :key="`Any${i}2`"
                    :label="v.operationVal"
                    :value="v.id"
                  />
                </el-select>
                <el-select v-model="item.anyFilteringBased" :disabled="!item.businessTypescheckAny" class="selectWidth">
                  <el-option
                    v-for="(v, i) in item.filterValue"
                    :key="`Any${i}3`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
              </div>
            </el-form-item>

            <span class="conditionsTitle">{{ $t('AutomaticRelease.meetAllConditions') }}</span>

            <el-form-item label-width="0" class="spacing newColumnRule">
              <div v-for="(item, index) in rules" :key="`1${index}`" class="newColumn">
                <el-checkbox v-model="item.businessTypescheckAll" :true-label="1" :false-label="0" />
                <el-select v-model="item.allType" :disabled="!item.businessTypescheckAll" class="selectWidth">
                  <el-option
                    v-for="(v, i) in item.filteringBased"
                    :key="`All${i}1`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
                <el-select v-model="item.allOperation" :disabled="!item.businessTypescheckAll" class="selectCenterWidth">
                  <el-option
                    v-for="(v, i) in item.operation"
                    :key="`All${i}2`"
                    :label="v.operationVal"
                    :value="v.id"
                  />
                </el-select>
                <el-select v-model="item.allFilteringBased" :disabled="!item.businessTypescheckAll" class="selectWidth">
                  <el-option
                    v-for="(v, i) in item.filterValue"
                    :key="`All${i}3`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
              </div>
            </el-form-item>

            <span class="businessTypes">{{ $t('AutomaticRelease.processingRules') }}</span>

            <el-form-item :label="$t('AutomaticRelease.SettlementBillMode')" label-width="104px" class="labelBoldStyle" />
            <span class="conditionsTitle" style="display:block;">
              <el-checkbox v-model="isCheck" :true-label="1" :false-label="0">{{ $t('AutomaticRelease.releaseDemand') }}</el-checkbox>
              <el-checkbox v-show="isCheck" v-model="form.settlementBillCheckCost" no="settlementBillCheckCost" :true-label="1" :false-label="0">{{ $t('AutomaticRelease.SettlementBillCheckCost') }}</el-checkbox>
            </span>
            <span class="conditionsTitle" style="display:block;">
              <el-checkbox v-model="isCheckCustomer" no="isCheckCustomer" :true-label="1" :false-label="0" style="margin-right:5px">{{ $t('AutomaticRelease.SettlementBillCustomer') }}</el-checkbox>
              <el-checkbox v-show="isCheckCustomer" v-model="form.settlementBillCustomerCheckCost" no="settlementBillCustomerCheckCost" :true-label="1" :false-label="0">{{ $t('AutomaticRelease.SettlementBillCustomerCheckCost') }}</el-checkbox>
            </span>
            <el-form-item :label="$t('AutomaticRelease.CreditObjectMode')" label-width="80px" class="labelBoldStyle" />
            <span class="conditionsTitle">{{ $t('AutomaticRelease.meetAnyConditions') }}</span>

            <el-form-item v-for="(item, index) in DisposeRules" :key="`2${index}`" label-width="0" class="spacing newColumnRule">
              <div class="newColumn">
                <el-checkbox v-model="item.checkAny" :disabled="Boolean(isCheck) || isCheckCustomer" :true-label="1" :false-label="0" />
                <el-select v-model="item.filteringBasedDisposeAnyRules" :disabled="!item.checkAny || Boolean(isCheck) || isCheckCustomer" class="selectWidth">
                  <el-option
                    v-for="(v, i) in item.validation"
                    :key="`Any1${i}`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
                <el-select v-model="item.operationDisposeAnyRules" :disabled="!item.checkAny || Boolean(isCheck) || isCheckCustomer" class="selectCenterWidth">
                  <el-option
                    v-for="(v, i) in item.operation"
                    :key="`Any2${i}`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
                <el-select v-model="item.filterValueDisposeAnyRules" :disabled="!item.checkAny || Boolean(isCheck) || isCheckCustomer" class="selectWidth">
                  <el-option
                    v-for="(v, i) in item.filterValue"
                    :key="`Any3${i}`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
              </div>

              <div v-for="(v, i) in ControlAnyChildrenRules" v-show="item.validation[0].value === $t('AutomaticRelease.common.creditObject') && item.checkAny && ControlAnyChildrenRules.length !== 0" :key="`3${i}`" class="newColumn">
                <div class="credit-control">
                  <div v-show="v.filteringBasedControlAnyChildrenRules === $t('AutomaticRelease.common.creditLimitAmount') || v.filteringBasedControlAnyChildrenRules === 'releaseDocRuleDataVo.creditLimitAmount'" style="margin-left: 23px;">
                    <div style="display:flex;">
                      <el-input-number
                        v-model="v.percentageControlAnyChildrenRules"
                        style="width:50px;"
                        :min="0"
                        :controls="false"
                      />
                      <span style="width:22px;text-align:center;">%</span>
                    </div>
                  </div>
                  <el-select
                    v-model="v.filteringBasedControlAnyChildrenRules"
                    class="selectWidth"
                    :class="v.filteringBasedControlAnyChildrenRules === $t('AutomaticRelease.common.creditLimitedDate') || v.filteringBasedControlAnyChildrenRules === 'releaseDocRuleDataVo.creditLimitedDate' || !v.filteringBasedControlAnyChildrenRules?'percentage':''"
                    style="width:80px;margin-left:0;"
                    @change="changed('ControlAnyChildren', v.filteringBasedControlAnyChildrenRules)"
                  >
                    <el-option
                      v-for="(childrenItem, index) in DisposeFilteringBased.ControlAnyChildrenCeditControl"
                      :key="`children${index}1`"
                      :label="childrenItem.value"
                      :value="childrenItem.id"
                    />
                  </el-select>
                </div>

                <el-select v-model="v.operationControlAnyChildrenRules" class="selectCenterWidth">
                  <el-option
                    v-for="(childrenItem, index) in DisposeFilteringBased.operation"
                    v-show="v.filteringBasedControlAnyChildrenRules === childrenItem.key || v.filteringBasedControlAnyChildrenRules === childrenItem.name"
                    :key="`children${index}2`"
                    :label="childrenItem.value"
                    :value="childrenItem.id"
                  />
                </el-select>

                <el-select v-model="v.filterValueControlAnyChildrenRules" class="selectWidth">
                  <el-option
                    v-for="(childrenItem, index) in DisposeFilteringBased.filterValue"
                    v-show="v.filteringBasedControlAnyChildrenRules === childrenItem.key || v.filteringBasedControlAnyChildrenRules === childrenItem.name"
                    :key="`children${index}3`"
                    :label="childrenItem.value"
                    :value="childrenItem.id"
                  />
                </el-select>
                <i
                  v-show="item.validation[0].value === $t('AutomaticRelease.common.creditObject') && item.checkAny && ControlAnyChildrenRules.length > 0"
                  class="el-icon-minus addIcon"
                  style="margin-left:10px;position:absolute;right:-25px;"
                  @click="deletes('ControlAnyChildren', i, v)"
                />
              </div>
              <i
                v-show="item.validation[0].value === $t('AutomaticRelease.common.creditObject') && item.checkAny && ControlAnyChildrenRules.length < 3"
                class="el-icon-plus addIcon"
                style="margin:5px 0 10px 0;"
                @click="creditControlAdd('ControlAnyChildren')"
              />
            </el-form-item>

            <span class="conditionsTitle">{{ $t('AutomaticRelease.meetAllConditions') }}</span>

            <el-form-item v-for="(item, index) in DisposeRules" :key="`3${index}`" label-width="0" class="spacing newColumnRule">
              <div class="newColumn">
                <el-checkbox v-model="item.checkAll" :disabled="Boolean(isCheck) || isCheckCustomer" :true-label="1" :false-label="0" />
                <el-select v-model="item.filteringBasedDisposeAllRules" :disabled="!item.checkAll || Boolean(isCheck) || isCheckCustomer" class="selectWidth">
                  <el-option
                    v-for="(v, i) in item.validation"
                    :key="`DisposeRules${i}1`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
                <el-select v-model="item.operationDisposeAllRules" :disabled="!item.checkAll || Boolean(isCheck) || isCheckCustomer" class="selectCenterWidth">
                  <el-option
                    v-for="(v, i) in item.operation"
                    :key="`DisposeRules${i}2`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
                <el-select v-model="item.filterValueDisposeAllRules" :disabled="!item.checkAll || Boolean(isCheck) || isCheckCustomer" class="selectWidth">
                  <el-option
                    v-for="(v, i) in item.filterValue"
                    :key="`DisposeRules${i}3`"
                    :label="v.value"
                    :value="v.id"
                  />
                </el-select>
              </div>

              <div v-show="item.validation[0].value === $t('AutomaticRelease.common.creditObject') && item.checkAll && (item.filterValueDisposeAllRules === 3 || item.filterValueDisposeAllRules === $t('AutomaticRelease.settlement'))" class="newColumn">
                <div class="credit-control">
                  <el-input disabled :value="$t('CargoMsg.Cargo_SettlementType')" style="width: 152px;margin-left: 23px" />
                </div>
                <el-select disabled value="==" class="selectCenterWidth">
                  <el-option :label="$t('AutomaticRelease.equal')" value="==" />
                </el-select>
                <el-input disabled :value="$t('CargoMsg.Cargo_SettlementNotByBill')" class="selectWidth" />
              </div>

              <div v-for="(v, i) in ControlAllChildrenRules" v-show="item.validation[0].value === $t('AutomaticRelease.common.creditObject') && item.checkAll && ControlAllChildrenRules.length !== 0" :key="`4${i}`" class="newColumn">
                <div class="credit-control">
                  <div v-show="v.filteringBasedControlAllChildrenRules === $t('AutomaticRelease.common.creditLimitAmount') || v.filteringBasedControlAllChildrenRules === 'releaseDocRuleDataVo.creditLimitAmount'" style="margin-left: 23px;">
                    <div style="display:flex;">
                      <el-input-number
                        v-model="v.percentageControlAllChildrenRules"
                        style="width:50px;"
                        :min="0"
                        :controls="false"
                      />
                      <span style="width:22px;text-align: center;">%</span>
                    </div>
                  </div>
                  <el-select
                    v-model="v.filteringBasedControlAllChildrenRules"
                    class="selectWidth"
                    style="width:80px;margin-left:0;"
                    :class="v.filteringBasedControlAllChildrenRules === $t('AutomaticRelease.common.creditLimitedDate') || v.filteringBasedControlAllChildrenRules === 'releaseDocRuleDataVo.creditLimitedDate' || !v.filteringBasedControlAllChildrenRules?'percentage':''"
                    @change="changed('ControlAllChildren', v.filteringBasedControlAllChildrenRules)"
                  >
                    <el-option
                      v-for="(childrenItem, index) in DisposeFilteringBased.ControlAllChildrenCeditControl"
                      :key="`Children1${index}1`"
                      :label="childrenItem.value"
                      :value="childrenItem.id"
                    />
                  </el-select>
                </div>
                <el-select v-model="v.operationControlAllChildrenRules" class="selectCenterWidth">
                  <el-option
                    v-for="(childrenItem, index) in DisposeFilteringBased.operation"
                    v-show="v.filteringBasedControlAllChildrenRules === childrenItem.key || v.filteringBasedControlAllChildrenRules === childrenItem.name"
                    :key="`Children2${index}2`"
                    :label="childrenItem.value"
                    :value="childrenItem.id"
                  />
                </el-select>
                <el-select v-model="v.filterValueControlAllChildrenRules" class="selectWidth">
                  <el-option
                    v-for="(childrenItem, index) in DisposeFilteringBased.filterValue"
                    v-show="v.filteringBasedControlAllChildrenRules === childrenItem.key || v.filteringBasedControlAllChildrenRules === childrenItem.name"
                    :key="`Children3${index}3`"
                    :label="childrenItem.value"
                    :value="childrenItem.id"
                  />
                </el-select>
                <i
                  v-show="item.validation[0].value === $t('AutomaticRelease.common.creditObject') && item.checkAll && ControlAllChildrenRules.length > 0"
                  class="el-icon-minus addIcon"
                  style="margin-left:10px;position:absolute;right:-25px;"
                  @click="deletes('ControlAllChildren', i, v)"
                />
              </div>
              <i
                v-show="item.validation[0].value === $t('AutomaticRelease.common.creditObject') && item.checkAll && ControlAllChildrenRules.length < 3"
                class="el-icon-plus addIcon"
                style="margin:5px 0 10px 0;"
                @click="creditControlAdd('ControlAllChildren')"
              />

              <template v-if="item.validation[0].value === $t('AutomaticRelease.common.creditObject') && item.checkAll && (item.filterValueDisposeAllRules === 3 || item.filterValueDisposeAllRules === $t('AutomaticRelease.settlement'))">
                <div style="font-size: 16px;font-weight: bold;margin-left: 25px;margin-bottom: -10px;">
                  {{ $t('SystemMaintenance.Just') }}
                </div>
                <div class="newColumn">
                  <div class="credit-control">
                    <el-input disabled :value="$t('CargoMsg.Cargo_SettlementType')" style="width: 152px;margin-left: 23px" />
                  </div>
                  <el-select disabled value="==" class="selectCenterWidth">
                    <el-option :label="$t('AutomaticRelease.equal')" value="==" />
                  </el-select>
                  <el-input disabled :value="$t('Message.ByTicket')" class="selectWidth" />
                </div>
                <div class="newColumn">
                  <div class="credit-control">
                    <el-input disabled :value="$t('SystemMaintenance.AccountsReceivable')" style="width: 152px;margin-left: 23px" />
                  </div>
                  <el-select disabled value="==" class="selectCenterWidth">
                    <el-option :label="$t('AutomaticRelease.equal')" value="==" />
                  </el-select>
                  <el-input disabled :value="$t('Billing.HasWriteOff')" class="selectWidth" />
                </div>
              </template>
            </el-form-item>

          </el-form>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="determine">{{ $t('AutomaticRelease.common.save') }}</el-button>
        <el-button @click="cancel">{{ $t('AutomaticRelease.common.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { saveReleaseDocRule, updateReleaseDocRule } from '@/api/sysManage/baseConfig/putASingleRule'
import { getLoading } from '@/utils/utilBaseElement'
export default {
  name: 'DialogRule',
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    branchList: {
      type: Array,
      default: null
    },
    tabIndex: {
      type: String,
      default: '0'
    }
  },
  data() {
    return {
      version: '',
      validationRules: {
        ruleName: [
          { required: true }
        ]
      },
      originalData: [], // 保存编辑时的初始数据，用于最后保存时对比删除的条数从而给予状态标识
      form: {
        ruleName: '',
        describe: '',
        uuid: '',
        chargeRecordState: 0, // 费用录入状态判断
        settlementBillCheckCost: false, // 无其他应收时，录入了向委托单位的应付，视为该票已付款
        settlementBillCustomerCheckCost: false // 无委托单位应收时，录入了向委托单位的应付，视为委托单位已付款
      },
      editorTag: false,
      isCheck: false,
      isCheckCustomer: false, // 仅校验委托单位应收已核销
      rules: [
        {
          businessTypescheckAny: false,
          businessTypescheckAll: false,
          anyType: this.$t('AutomaticRelease.common.docType'),
          anyOperation: '',
          anyFilteringBased: '',
          allType: this.$t('AutomaticRelease.common.docType'),
          allOperation: '',
          allFilteringBased: '',
          filteringBased: [
            {
              value: this.$t('AutomaticRelease.common.docType'),
              id: 'releaseDocRuleDataVo.docType'
            }
          ],
          operation: [
            {
              operationVal: this.$t('AutomaticRelease.equal'),
              id: '=='
            },
            {
              operationVal: this.$t('AutomaticRelease.neq'),
              id: '!='
            }
          ],
          filterValue: [
            {
              value: 'MBL',
              id: 'MBL'
            },
            {
              value: 'HBL',
              id: 'HBL'
            }
          ]
        },
        {
          businessTypescheckAny: false,
          businessTypescheckAll: false,
          anyType: this.$t('AutomaticRelease.common.customerSelfRelease'),
          anyOperation: '',
          anyFilteringBased: '',
          allType: this.$t('AutomaticRelease.common.customerSelfRelease'),
          allOperation: '',
          allFilteringBased: '',
          filteringBased: [
            {
              value: this.$t('AutomaticRelease.common.customerSelfRelease'),
              id: 'releaseDocRuleDataVo.customerSelfRelease'
            }
          ],
          operation: [
            {
              operationVal: this.$t('AutomaticRelease.equal'),
              id: '=='
            },
            {
              operationVal: this.$t('AutomaticRelease.neq'),
              id: '!='
            }
          ],
          filterValue: [
            {
              value: this.$t('AutomaticRelease.customerIssuing'),
              id: 1
            },
            {
              value: this.$t('AutomaticRelease.issuedCompany'),
              id: 2
            }
          ]
        },
        {
          businessTypescheckAny: false,
          businessTypescheckAll: false,
          anyType: this.$t('AutomaticRelease.common.releaseType'),
          anyOperation: '',
          anyFilteringBased: '',
          allType: this.$t('AutomaticRelease.common.releaseType'),
          allOperation: '',
          allFilteringBased: '',
          filteringBased: [
            {
              value: this.$t('AutomaticRelease.common.releaseType'),
              id: 'releaseDocRuleDataVo.releaseType'
            }
          ],
          operation: [
            {
              operationVal: this.$t('AutomaticRelease.equal'),
              id: '=='
            },
            {
              operationVal: this.$t('AutomaticRelease.neq'),
              id: '!='
            }
          ],
          filterValue: [
            {
              value: this.$t('AutomaticRelease.original'),
              id: 1
            },
            {
              value: this.$t('AutomaticRelease.telexRelease'),
              id: 2
            }
          ]
        },
        {
          businessTypescheckAny: false,
          businessTypescheckAll: false,
          anyType: this.$t('AutomaticRelease.common.cargoSource'),
          anyOperation: '',
          anyFilteringBased: '',
          allType: this.$t('AutomaticRelease.common.cargoSource'),
          allOperation: '',
          allFilteringBased: '',
          filteringBased: [
            {
              value: this.$t('AutomaticRelease.common.cargoSource'),
              id: 'releaseDocRuleDataVo.cargoSource'
            }
          ],
          operation: [
            {
              operationVal: this.$t('AutomaticRelease.equal'),
              id: '=='
            },
            {
              operationVal: this.$t('AutomaticRelease.neq'),
              id: '!='
            }
          ],
          filterValue: [
            {
              value: this.$t('AutomaticRelease.SC'),
              id: 'SC'
            },
            {
              value: this.$t('AutomaticRelease.NC'),
              id: 'NC'
            }
          ]
        },
        {
          businessTypescheckAny: false,
          businessTypescheckAll: false,
          anyType: this.$t('AutomaticRelease.common.customerType'),
          anyOperation: '',
          anyFilteringBased: '',
          allType: this.$t('AutomaticRelease.common.customerType'),
          allOperation: '',
          allFilteringBased: '',
          filteringBased: [
            {
              value: this.$t('AutomaticRelease.common.customerType'),
              id: 'releaseDocRuleDataVo.customerType'
            }
          ],
          operation: [
            {
              operationVal: this.$t('AutomaticRelease.equal'),
              id: '=='
            },
            {
              operationVal: this.$t('AutomaticRelease.neq'),
              id: '!='
            }
          ],
          filterValue: [
            {
              value: this.$t('Partners.peers'),
              id: 'PEER'
            }
          ]
        }
      ],
      DisposeRules: [
        {
          checkAll: false,
          checkAny: false,
          filteringBasedDisposeAnyRules: this.$t('AutomaticRelease.common.creditObject'),
          operationDisposeAnyRules: '',
          filterValueDisposeAnyRules: '',
          filteringBasedDisposeAllRules: this.$t('AutomaticRelease.common.creditObject'),
          operationDisposeAllRules: '',
          filterValueDisposeAllRules: '',
          validation: [
            {
              value: this.$t('AutomaticRelease.common.creditObject'),
              id: 'releaseDocRuleDataVo.creditObject'
            }
          ],
          operation: [
            {
              value: this.$t('AutomaticRelease.equal'),
              id: '=='
            }
          ],
          filterValue: [
            {
              value: this.$t('AutomaticRelease.client'),
              id: 1
            },
            {
              value: this.$t('AutomaticRelease.agent'),
              id: 2
            },
            {
              value: this.$t('AutomaticRelease.settlement'),
              id: 3
            }
          ]
        }
        // {
        //   checkAll: false,
        //   checkAny: false,
        //   filteringBasedDisposeAnyRules: 'this.$t('AutomaticRelease.receivableType')',
        //   operationDisposeAnyRules: '',
        //   filterValueDisposeAnyRules: '',
        //   filteringBasedDisposeAllRules: 'this.$t('AutomaticRelease.receivableType')',
        //   operationDisposeAllRules: '',
        //   filterValueDisposeAllRules: '',
        //   validation: [
        //     {
        //       value: 'this.$t('AutomaticRelease.receivableType')',
        //       id: 'releaseDocRuleDataVo.receivableType'
        //     }
        //   ],
        //   operation: [
        //     {
        //       value: '等于',
        //       id: '=='
        //     },
        //     {
        //       value: '不等于',
        //       id: '!='
        //     }
        //   ],
        //   filterValue: [
        //     {
        //       value: '收款',
        //       id: 1
        //     }
        //   ]
        // }
      ],
      disposeSettlementBill: {
        conditionType: 4,
        matchField: 'releaseDocRuleDataVo.settlementBill',
        matchOperator: '==',
        matchValue: 'true'
      },
      // 放单信控子类接收数据数组
      ControlAnyChildrenRules: [],
      ControlAllChildrenRules: [],
      DisposeOperation: [],
      TypeMapping: {
        'releaseDocRuleDataVo.docType': this.$t('AutomaticRelease.common.docType'),
        'releaseDocRuleDataVo.customerSelfRelease': this.$t('AutomaticRelease.common.customerSelfRelease'),
        'releaseDocRuleDataVo.releaseType': this.$t('AutomaticRelease.common.releaseType'),
        'releaseDocRuleDataVo.cargoSource': this.$t('AutomaticRelease.common.cargoSource'),
        'releaseDocRuleDataVo.customerType': this.$t('AutomaticRelease.common.customerType'),
        'releaseDocRuleDataVo.creditObject': this.$t('AutomaticRelease.common.creditObject'),
        'releaseDocRuleDataVo.receivableType': this.$t('AutomaticRelease.common.receivableType'),
        'releaseDocRuleDataVo.creditLimitedDate': this.$t('AutomaticRelease.common.creditLimitedDate'),
        'releaseDocRuleDataVo.creditLimitAmount': this.$t('AutomaticRelease.common.creditLimitAmount'),
        'releaseDocRuleDataVo.creditLimitedETD': this.$t('AutomaticRelease.common.creditLimitedETD')
      },
      operationMapping: {
        '==': this.$t('AutomaticRelease.equal'),
        '!=': this.$t('AutomaticRelease.neq'),
        '>=': this.$t('AutomaticRelease.exceed'),
        '<': this.$t('AutomaticRelease.notMore')
      },
      filterValueMapping: {
        'SC': this.$t('AutomaticRelease.SC'),
        'NC': this.$t('AutomaticRelease.NC'),
        'MBL': 'MBL',
        'HBL': 'HBL',
        'releaseDocRuleDataVo.creditUsedLimitAmount': this.$t('AutomaticRelease.creditUsedLimitAmount'),
        'creditLimitedETDDays': this.$t('AutomaticRelease.creditLimitedETDDays'),
        'releaseDocRuleDataVo.creditLimitedETDDays': this.$t('AutomaticRelease.creditLimitedETDDays')
      },
      // 放单信控子类列表数据
      DisposeFilteringBased: {
        ControlAnyChildrenCeditControl: [
          {
            value: this.$t('AutomaticRelease.common.creditLimitedDate'),
            id: 'releaseDocRuleDataVo.creditLimitedDate'
          },
          {
            value: this.$t('AutomaticRelease.common.creditLimitAmount'),
            id: 'releaseDocRuleDataVo.creditLimitAmount'
          },
          {
            value: this.$t('AutomaticRelease.common.creditLimitedETD'),
            id: 'releaseDocRuleDataVo.creditLimitedETD'
          }
        ],
        ControlAllChildrenCeditControl: [
          {
            value: this.$t('AutomaticRelease.common.creditLimitedDate'),
            id: 'releaseDocRuleDataVo.creditLimitedDate'
          },
          {
            value: this.$t('AutomaticRelease.common.creditLimitAmount'),
            id: 'releaseDocRuleDataVo.creditLimitAmount'
          },
          {
            value: this.$t('AutomaticRelease.common.creditLimitedETD'),
            id: 'releaseDocRuleDataVo.creditLimitedETD'
          }
        ],
        operation: [
          {
            value: this.$t('AutomaticRelease.exceed'),
            key: 'releaseDocRuleDataVo.creditLimitAmount',
            name: this.$t('AutomaticRelease.common.creditLimitAmount'),
            id: '>='
          },
          {
            value: this.$t('AutomaticRelease.notMore'),
            key: 'releaseDocRuleDataVo.creditLimitAmount',
            name: this.$t('AutomaticRelease.common.creditLimitAmount'),
            id: '<'
          },
          {
            value: this.$t('AutomaticRelease.exceed'),
            key: 'releaseDocRuleDataVo.creditLimitedDate',
            name: this.$t('AutomaticRelease.common.creditLimitedDate'),
            id: '=='
          },
          {
            value: this.$t('AutomaticRelease.notMore'),
            key: 'releaseDocRuleDataVo.creditLimitedDate',
            name: this.$t('AutomaticRelease.common.creditLimitedDate'),
            id: '!='
          },
          {
            value: this.$t('AutomaticRelease.exceed'),
            key: 'releaseDocRuleDataVo.creditLimitedETD',
            name: this.$t('AutomaticRelease.common.creditLimitedETD'),
            id: '>='
          },
          {
            value: this.$t('AutomaticRelease.notMore'),
            key: 'releaseDocRuleDataVo.creditLimitedETD',
            name: this.$t('AutomaticRelease.common.creditLimitedETD'),
            id: '<'
          }
        ],
        filterValue: [
          {
            value: this.$t('AutomaticRelease.accountingPeriod'),
            key: 'releaseDocRuleDataVo.creditLimitedDate',
            name: this.$t('AutomaticRelease.common.creditLimitedDate'),
            id: true
          },
          {
            value: this.$t('AutomaticRelease.creditUsedLimitAmount'),
            key: 'releaseDocRuleDataVo.creditLimitAmount',
            name: this.$t('AutomaticRelease.common.creditLimitAmount'),
            id: 'releaseDocRuleDataVo.creditUsedLimitAmount'
          },
          {
            value: this.$t('AutomaticRelease.creditLimitedETDDays'),
            key: 'releaseDocRuleDataVo.creditLimitedETD',
            name: this.$t('AutomaticRelease.common.creditLimitedETD'),
            id: 'creditLimitedETDDays'
          }
        ]
      },
      chargeRecordStates: []
    }
  },
  watch: {
    // 勾选见款放单时 重置任意条件勾选状态
    isCheck(value) {
      if (value) {
        this.isCheckCustomer = false
        this.form.settlementBillCustomerCheckCost = false
        this.DisposeRules.map((item) => {
          item.checkAny = false
          item.checkAll = false
        })
      }
    },
    isCheckCustomer(value) {
      if (value) {
        this.isCheck = false
        this.form.settlementBillCheckCost = false
      }
    }
  },
  created() {
    this.chargeRecordStates.push({ label: this.$t('AutomaticRelease.ChargeRecordState0'), value: 0 })
    this.chargeRecordStates.push({ label: this.$t('AutomaticRelease.ChargeRecordState1'), value: 1 })
    this.chargeRecordStates.push({ label: this.$t('AutomaticRelease.ChargeRecordState2'), value: 2 })
  },
  methods: {
    // 确定
    async determine() {
      this.loading = getLoading()
      let prompt = []
      if (!this.form.ruleName.trim()) {
        prompt.push(this.$t('AutomaticRelease.ruleName1'))
      }
      if (this.assemblyData(this.rules).length === 0) {
        prompt.push(this.$t('AutomaticRelease.businessTypes'))
      }
      if (this.assemblyData(this.DisposeRules).length === 0 && !this.isCheck && !this.isCheckCustomer) {
        prompt.push(this.$t('AutomaticRelease.processingRules'))
      }
      if (prompt.length > 0) {
        prompt = prompt.join('、')
        const tips = this.$t('AutomaticRelease.prompt').replace('${prompt}', prompt)
        this.$message.warning(tips)
        this.loading.close()
        return
      }
      const releaseDocMatchConditionVoList = [
        ...this.assemblyData(this.rules),
        ...this.assemblyData(this.DisposeRules)
      ]
      if (this.creditControlIsCheck(releaseDocMatchConditionVoList, 3)) {
        releaseDocMatchConditionVoList.push(...this.assemblyData(this.ControlAnyChildrenRules, 'children3'))
      }
      if (this.creditControlIsCheck(releaseDocMatchConditionVoList, 4)) {
        releaseDocMatchConditionVoList.push(...this.assemblyData(this.ControlAllChildrenRules, 'children4'))
      }
      releaseDocMatchConditionVoList.forEach((item) => {
        this.saveMapping(item)
      })
      const isAddSettlementBill = releaseDocMatchConditionVoList.findIndex(p => p.conditionType === 4 && p.matchField === 'releaseDocRuleDataVo.creditObject' && p.matchValue === 3) > -1
      if (isAddSettlementBill) {
        releaseDocMatchConditionVoList.push(this.disposeSettlementBill)
      }
      // 判断===''而不是使用！是因为字段中会布尔值的值
      if (releaseDocMatchConditionVoList.find(item => item.matchOperator === '' || item.matchValue === '')) {
        this.$message.warning(this.$t('AutomaticRelease.Tips1'))
        this.loading.close()
        return
      }
      const data = {
        ruleName: this.form.ruleName,
        ruleDescription: this.form.describe,
        uuid: this.form.uuid,
        version: this.version,
        settlementBill: Boolean(this.isCheck), // 见款放单
        chargeRecordState: this.form.chargeRecordState, // 费用录入状态判断
        settlementBillCheckCost: Boolean(this.form.settlementBillCheckCost),
        settlementBillCustomer: Boolean(this.isCheckCustomer), // 仅校验委托单位应收已核销
        settlementBillCustomerCheckCost: Boolean(this.form.settlementBillCustomerCheckCost),
        releaseDocMatchConditionVoList: releaseDocMatchConditionVoList // 数据集合
      }
      let res = null
      if (this.editorTag) {
        res = await updateReleaseDocRule(data).finally(() => {
          this.loading.close()
        })
      } else {
        res = await saveReleaseDocRule(data).finally(() => {
          this.loading.close()
        })
      }
      if (res) {
        this.$emit('getList')
        this.$emit('cancel', false)
        this.reset()
        this.$message.success(this.$t('AutomaticRelease.successRemind'))
      }
    },
    // 编辑弹出弹窗进行数据转换
    onShow(data) {
      this.editorTag = true
      this.form.ruleName = data.ruleName
      this.form.describe = data.ruleDescription
      this.form.uuid = data.uuid
      this.isCheck = Number(data.settlementBill)
      this.form.chargeRecordState = data.chargeRecordState
      this.form.settlementBillCheckCost = Number(data.settlementBillCheckCost)
      this.isCheckCustomer = Number(data.settlementBillCustomer)
      this.form.settlementBillCustomerCheckCost = Number(data.settlementBillCustomerCheckCost)
      this.originalData = data
      this.version = data.version
      data.releaseDocMatchConditionVoList.map((item) => {
        switch (item.conditionType) {
          case 1:
            this.rules.forEach((i) => {
              this.conversionMapping(i, item, 'businessTypescheckAny', 'anyType', 'anyOperation', 'anyFilteringBased', 'anyUuid', 'anyRuleUuid', 'anyVersion')
            })
            break
          case 2:
            this.rules.forEach((i) => {
              this.conversionMapping(i, item, 'businessTypescheckAll', 'anyType', 'allOperation', 'allFilteringBased', 'allUuid', 'allRuleUuid', 'allVersion')
            })
            break
          case 3:
            this.DisposeRules.forEach((i) => {
              this.conversionMapping(i, item, 'checkAny', 'filteringBasedDisposeAnyRules', 'operationDisposeAnyRules', 'filterValueDisposeAnyRules', 'anyUuid', 'anyRuleUuid', 'anyVersion')
            })
            if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.creditLimitAmount')) {
              const index = this.DisposeFilteringBased.ControlAnyChildrenCeditControl.findIndex((p) => p.value === this.TypeMapping[item.matchField])
              this.DisposeFilteringBased.ControlAnyChildrenCeditControl.splice(index, 1)
              this.ControlAnyChildrenRules.push({
                filteringBasedControlAnyChildrenRules: this.TypeMapping[item.matchField],
                operationControlAnyChildrenRules: this.operationMapping[item.matchOperator],
                filterValueControlAnyChildrenRules: this.filterValueMapping[item.matchValue],
                percentageControlAnyChildrenRules: item.percentage * 100,
                version: item.version,
                uuid: item.uuid,
                ruleUuid: item.ruleUuid
              })
            }
            if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.creditLimitedDate')) {
              const index = this.DisposeFilteringBased.ControlAnyChildrenCeditControl.findIndex((p) => p.value === this.TypeMapping[item.matchField])
              this.DisposeFilteringBased.ControlAnyChildrenCeditControl.splice(index, 1)
              this.ControlAnyChildrenRules.push({
                filteringBasedControlAnyChildrenRules: this.TypeMapping[item.matchField],
                operationControlAnyChildrenRules: item.matchOperator === '==' ? this.$t('AutomaticRelease.exceed') : this.$t('AutomaticRelease.notMore'),
                filterValueControlAnyChildrenRules: this.$t('AutomaticRelease.accountingPeriod'),
                version: item.version,
                uuid: item.uuid,
                ruleUuid: item.ruleUuid
              })
            }
            if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.creditLimitedETD')) {
              const index = this.DisposeFilteringBased.ControlAnyChildrenCeditControl.findIndex((p) => p.value === this.TypeMapping[item.matchField])
              this.DisposeFilteringBased.ControlAnyChildrenCeditControl.splice(index, 1)
              this.ControlAnyChildrenRules.push({
                filteringBasedControlAnyChildrenRules: this.TypeMapping[item.matchField],
                operationControlAnyChildrenRules: this.operationMapping[item.matchOperator],
                filterValueControlAnyChildrenRules: this.filterValueMapping[item.matchValue],
                version: item.version,
                uuid: item.uuid,
                ruleUuid: item.ruleUuid
              })
            }
            break
          case 4:
            this.DisposeRules.forEach((i) => {
              this.conversionMapping(i, item, 'checkAll', 'filteringBasedDisposeAllRules', 'operationDisposeAllRules', 'filterValueDisposeAllRules', 'allUuid', 'allRuleUuid', 'allVersion')
            })
            if (item.matchField === 'releaseDocRuleDataVo.settlementBill') {
              Object.assign(this.disposeSettlementBill, item)
            }
            if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.creditLimitAmount')) {
              const index = this.DisposeFilteringBased.ControlAllChildrenCeditControl.findIndex((p) => p.value === this.TypeMapping[item.matchField])
              this.DisposeFilteringBased.ControlAllChildrenCeditControl.splice(index, 1)
              this.ControlAllChildrenRules.push({
                filteringBasedControlAllChildrenRules: this.TypeMapping[item.matchField],
                operationControlAllChildrenRules: this.operationMapping[item.matchOperator],
                filterValueControlAllChildrenRules: this.filterValueMapping[item.matchValue],
                percentageControlAllChildrenRules: item.percentage * 100,
                version: item.version,
                uuid: item.uuid,
                ruleUuid: item.ruleUuid
              })
            }
            if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.creditLimitedDate')) {
              const index = this.DisposeFilteringBased.ControlAllChildrenCeditControl.findIndex((p) => p.value === this.TypeMapping[item.matchField])
              this.DisposeFilteringBased.ControlAllChildrenCeditControl.splice(index, 1)
              this.ControlAllChildrenRules.push({
                filteringBasedControlAllChildrenRules: this.TypeMapping[item.matchField],
                operationControlAllChildrenRules: item.matchOperator === '==' ? this.$t('AutomaticRelease.exceed') : this.$t('AutomaticRelease.notMore'),
                filterValueControlAllChildrenRules: this.$t('AutomaticRelease.accountingPeriod'),
                version: item.version,
                uuid: item.uuid,
                ruleUuid: item.ruleUuid
              })
            }
            if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.creditLimitedETD')) {
              const index = this.DisposeFilteringBased.ControlAllChildrenCeditControl.findIndex((p) => p.value === this.TypeMapping[item.matchField])
              this.DisposeFilteringBased.ControlAllChildrenCeditControl.splice(index, 1)
              this.ControlAllChildrenRules.push({
                filteringBasedControlAllChildrenRules: this.TypeMapping[item.matchField],
                operationControlAllChildrenRules: this.operationMapping[item.matchOperator],
                filterValueControlAllChildrenRules: this.filterValueMapping[item.matchValue],
                version: item.version,
                uuid: item.uuid,
                ruleUuid: item.ruleUuid
              })
            }
            break
        }
      })
    },
    // 整合数据
    assemblyData(data, children) {
      const arr = []
      data.map((item) => {
        // businessTypescheckAny表示任意业务类型已勾选
        if (item.businessTypescheckAny) {
          arr.push({
            ...this.distinguishType(1, item, 'anyUuid', 'anyRuleUuid', 'anyVersion')
          })
        }
        // businessTypescheckAny表示所有业务类型已勾选
        if (item.businessTypescheckAll) {
          arr.push({
            ...this.distinguishType(2, item, 'allUuid', 'allRuleUuid', 'allVersion')
          })
        }

        // checkAny表示任意处理规则已勾选
        if (item.checkAny) {
          arr.push({
            ...this.distinguishType(3, item, 'anyUuid', 'anyRuleUuid', 'anyVersion')
          })
        }
        // checkAny表示所有处理规则已勾选
        if (item.checkAll) {
          arr.push({
            ...this.distinguishType(4, item, 'allUuid', 'allRuleUuid', 'allVersion')
          })
        }

        // 信控账期
        if (children === 'children3') {
          arr.push({
            ...this.distinguishType(children, item)
          })
        }

        // 信控额度
        if (children === 'children4') {
          arr.push({
            ...this.distinguishType(children, item)
          })
        }
      })
      return arr
    },
    // 处理不同类型的值
    distinguishType(type, item, allUuid, allRuleUuid, versions) {
      switch (type) {
        case 1:
          return {
            conditionType: type,
            matchField: item.anyType, // 类型
            matchOperator: item.anyOperation, // 操作
            matchValue: item.anyFilteringBased, // 过滤值
            version: item[versions],
            uuid: item[allUuid],
            ruleUuid: item[allRuleUuid]
          }
        case 2:
          return {
            conditionType: type,
            matchField: item.allType, // 类型
            matchOperator: item.allOperation, // 操作
            matchValue: item.allFilteringBased, // 过滤值
            version: item[versions],
            uuid: item[allUuid],
            ruleUuid: item[allRuleUuid]
          }
        case 3:
          return {
            conditionType: type,
            matchField: item.filteringBasedDisposeAnyRules, // 类型
            matchOperator: item.operationDisposeAnyRules, // 操作
            matchValue: item.filterValueDisposeAnyRules, // 过滤值
            version: item[versions],
            uuid: item[allUuid],
            ruleUuid: item[allRuleUuid]
          }
        case 4:
          return {
            conditionType: type,
            matchField: item.filteringBasedDisposeAllRules, // 类型
            matchOperator: item.operationDisposeAllRules, // 操作
            matchValue: item.filterValueDisposeAllRules, // 过滤值
            version: item[versions],
            uuid: item[allUuid],
            ruleUuid: item[allRuleUuid]
          }
        case 'children3':
          return {
            conditionType: 3,
            matchField: item.filteringBasedControlAnyChildrenRules, // 类型
            matchOperator: item.operationControlAnyChildrenRules, // 操作
            matchValue: item.filterValueControlAnyChildrenRules, // 过滤值
            percentage: item.percentageControlAnyChildrenRules,
            version: item.version,
            uuid: item.uuid,
            ruleUuid: item.ruleUuid
          }
        case 'children4':
          return {
            conditionType: 4,
            matchField: item.filteringBasedControlAllChildrenRules, // 类型
            matchOperator: item.operationControlAllChildrenRules, // 操作
            matchValue: item.filterValueControlAllChildrenRules, // 过滤值
            percentage: item.percentageControlAllChildrenRules,
            version: item.version,
            uuid: item.uuid,
            ruleUuid: item.ruleUuid
          }
      }
    },
    // 信控勾选判断
    creditControlIsCheck(releaseDocMatchConditionVoList, type) {
      return releaseDocMatchConditionVoList.some((item) => {
        return item.conditionType === type && (item.matchField === 'releaseDocRuleDataVo.creditObject' || item.matchField === this.$t('AutomaticRelease.common.creditObject'))
      })
    },
    // 子类添加
    creditControlAdd(value) {
      const obj = {}
      const deleteObj = this.DisposeFilteringBased[`${value}CeditControl`].shift()
      obj[`filteringBased${value}Rules`] = deleteObj.value
      obj[`operation${value}Rules`] = ''
      obj[`filterValue${value}Rules`] = ''
      obj[`percentage${value}Rules`] = ''
      this[`${value}Rules`].push({
        ...obj
      })
    },
    // 切换值时清空关联下拉框的值
    changed(key, name) {
      if (name) {
        this[`${key}Rules`].forEach((item) => {
          if (item[`filteringBased${key}Rules`] === name) {
            item[`operation${key}Rules`] = ''
            item[`filterValue${key}Rules`] = ''
            item[`percentage${key}Rules`] = ''
            item[`filteringBased${key}Rules`] = this.TypeMapping[name]
          }
          if (name === 'releaseDocRuleDataVo.creditLimitAmount') {
            this.DisposeFilteringBased[`${key}CeditControl`] = [{
              value: this.$t('AutomaticRelease.common.creditLimitedDate'),
              id: 'releaseDocRuleDataVo.creditLimitedDate'
            }, {
              value: this.$t('AutomaticRelease.common.creditLimitedETD'),
              id: 'releaseDocRuleDataVo.creditLimitedETD'
            }]
          }
          if (name === 'releaseDocRuleDataVo.creditLimitedDate') {
            this.DisposeFilteringBased[`${key}CeditControl`] = [{
              value: this.$t('AutomaticRelease.common.creditLimitAmount'),
              id: 'releaseDocRuleDataVo.creditLimitAmount'
            }, {
              value: this.$t('AutomaticRelease.common.creditLimitedETD'),
              id: 'releaseDocRuleDataVo.creditLimitedETD'
            }]
          }
          if (name === 'releaseDocRuleDataVo.creditLimitedETD') {
            this.DisposeFilteringBased[`${key}CeditControl`] = [{
              value: this.$t('AutomaticRelease.common.creditLimitedDate'),
              id: 'releaseDocRuleDataVo.creditLimitedDate'
            }, {
              value: this.$t('AutomaticRelease.common.creditLimitAmount'),
              id: 'releaseDocRuleDataVo.creditLimitAmount'
            }]
          }
        })
      }
    },
    // 信控点击减号按钮
    deletes(key, index, v) {
      this[`${key}Rules`].splice(index, 1)
      let id = ''
      if (v[`filteringBased${key}Rules`] === this.$t('AutomaticRelease.common.creditLimitAmount')) {
        id = 'releaseDocRuleDataVo.creditLimitAmount'
      }
      if (v[`filteringBased${key}Rules`] === this.$t('AutomaticRelease.common.creditLimitedDate')) {
        id = 'releaseDocRuleDataVo.creditLimitedDate'
      }
      if (v[`filteringBased${key}Rules`] === this.$t('AutomaticRelease.common.creditLimitedETD')) {
        id = 'releaseDocRuleDataVo.creditLimitedETD'
      }
      this.DisposeFilteringBased[`${key}CeditControl`].push({
        value: v[`filteringBased${key}Rules`],
        id: id
      })
    },
    // 转换映射
    conversionMapping(i, item, businessTypescheck, filteringBased, operation, filterValue, uuidType, ruleUuid, version) {
      if (i[filteringBased] === this.TypeMapping[item.matchField]) {
        i[businessTypescheck] = 1
        i[operation] = this.operationMapping[item.matchOperator]
        i[filterValue] = this.filterValueMapping[item.matchValue]
        if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.customerSelfRelease')) {
          i[filterValue] = item.matchValue === '1' ? this.$t('AutomaticRelease.customerIssuing') : this.$t('AutomaticRelease.issuedCompany')
        }
        if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.releaseType')) {
          i[filterValue] = item.matchValue === '1' ? this.$t('AutomaticRelease.original') : this.$t('AutomaticRelease.telexRelease')
        }
        if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.creditObject')) {
          switch (item.matchValue) {
            case '1':
              i[filterValue] = this.$t('AutomaticRelease.client')
              break
            case '2':
              i[filterValue] = this.$t('AutomaticRelease.agent')
              break
            case '3':
              i[filterValue] = this.$t('AutomaticRelease.settlement')
              break
          }
        }
        if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.receivableType')) {
          i[filterValue] = item.matchValue === '1' ? this.$t('AutomaticRelease.collection') : ''
        }
        if (this.TypeMapping[item.matchField] === this.$t('AutomaticRelease.common.customerType')) {
          i[filterValue] = item.matchValue === 'PEER' ? this.$t('Partners.peers') : ''
        }
        i[version] = item.version
        i[uuidType] = item.uuid
        i[ruleUuid] = item.ruleUuid
      }
    },
    // 保存时转换映射
    saveMapping(item) {
      switch (item.matchField) {
        case this.$t('AutomaticRelease.common.docType'):
          item.matchField = 'releaseDocRuleDataVo.docType'
          break
        case this.$t('AutomaticRelease.common.customerSelfRelease'):
          item.matchField = 'releaseDocRuleDataVo.customerSelfRelease'
          break
        case this.$t('AutomaticRelease.common.releaseType'):
          item.matchField = 'releaseDocRuleDataVo.releaseType'
          break
        case this.$t('AutomaticRelease.common.cargoSource'):
          item.matchField = 'releaseDocRuleDataVo.cargoSource'
          break
        case this.$t('AutomaticRelease.common.creditObject'):
          item.matchField = 'releaseDocRuleDataVo.creditObject'
          break
        case this.$t('AutomaticRelease.common.receivableType'):
          item.matchField = 'releaseDocRuleDataVo.receivableType'
          break
        case this.$t('AutomaticRelease.common.creditLimitedDate'):
          item.matchField = 'releaseDocRuleDataVo.creditLimitedDate'
          break
        case this.$t('AutomaticRelease.common.creditLimitAmount'):
          item.matchField = 'releaseDocRuleDataVo.creditLimitAmount'
          break
        case this.$t('AutomaticRelease.common.creditLimitedETD'):
          item.matchField = 'releaseDocRuleDataVo.creditLimitedETD'
          break
        case this.$t('AutomaticRelease.common.customerType'):
          item.matchField = 'releaseDocRuleDataVo.customerType'
          break
      }
      switch (item.matchOperator) {
        case this.$t('AutomaticRelease.equal'):
          item.matchOperator = '=='
          break
        case this.$t('AutomaticRelease.neq'):
          item.matchOperator = '!='
          break
      }
      if (item.matchField === 'releaseDocRuleDataVo.creditLimitedDate') {
        switch (item.matchOperator) {
          case this.$t('AutomaticRelease.exceed'):
            item.matchOperator = '=='
            break
          case this.$t('AutomaticRelease.notMore'):
            item.matchOperator = '!='
            break
        }
      }
      if (item.matchField === 'releaseDocRuleDataVo.creditLimitAmount') {
        switch (item.matchOperator) {
          case this.$t('AutomaticRelease.exceed'):
            item.matchOperator = '>='
            break
          case this.$t('AutomaticRelease.notMore'):
            item.matchOperator = '<'
            break
        }
      }
      if (item.matchField === 'releaseDocRuleDataVo.creditLimitedETD') {
        switch (item.matchOperator) {
          case this.$t('AutomaticRelease.exceed'):
            item.matchOperator = '>'
            break
          case this.$t('AutomaticRelease.notMore'):
            item.matchOperator = '<='
            break
        }
      }
      switch (item.matchValue) {
        case 'MBL':
          item.matchValue = 'MBL'
          break
        case 'HBL':
          item.matchValue = 'HBL'
          break
        case this.$t('AutomaticRelease.SC'):
          item.matchValue = 'SC'
          break
        case this.$t('AutomaticRelease.NC'):
          item.matchValue = 'NC'
          break
        case this.$t('AutomaticRelease.creditUsedLimitAmount'):
          item.matchValue = 'releaseDocRuleDataVo.creditUsedLimitAmount'
          break
        case this.$t('AutomaticRelease.accountingPeriod'):
          item.matchValue = true
          break
        case this.$t('AutomaticRelease.creditLimitedETDDays'):
          item.matchValue = 'releaseDocRuleDataVo.creditLimitedETDDays'
          break
        case 'creditLimitedETDDays':
          item.matchValue = 'releaseDocRuleDataVo.creditLimitedETDDays'
          break
        case this.$t('AutomaticRelease.collection'):
        case this.$t('AutomaticRelease.client'):
        case this.$t('AutomaticRelease.original'):
        case this.$t('AutomaticRelease.customerIssuing'):
          item.matchValue = 1
          break
        case this.$t('AutomaticRelease.agent'):
        case this.$t('AutomaticRelease.telexRelease'):
        case this.$t('AutomaticRelease.issuedCompany'):
          item.matchValue = 2
          break
        case this.$t('AutomaticRelease.settlement'):
          item.matchValue = 3
          break
        case this.$t('Partners.peers'):
          item.matchValue = 'PEER'
          break
      }
      item.percentage = item.percentage / 100
    },
    // 取消
    cancel() {
      this.$emit('cancel', false)
      this.reset()
    },
    // 重置窗口参数
    reset() {
      this.form = {
        ruleName: '',
        describe: '',
        uuid: '',
        chargeRecordState: 0,
        settlementBillCheckCost: false,
        settlementBillCustomerCheckCost: false
      }
      this.editorTag = false // 是否为编辑模式标记，关闭弹窗时标记false
      this.isCheck = false
      this.isCheckCustomer = false
      this.rules.forEach((item) => {
        item.businessTypescheckAny = false
        item.businessTypescheckAll = false
        item.anyType = item.filteringBased[0].value
        item.allType = item.filteringBased[0].value
        item.anyRuleUuid = ''
        item.anyUuid = ''
        item.allRuleUuid = ''
        item.allUuid = ''
        item.anyOperation = ''
        item.allOperation = ''
        item.anyFilteringBased = ''
        item.allFilteringBased = ''
        item.uuid = ''
        item.allVersion = ''
        item.anyVersion = ''
        item.ruleUuid = ''
        item.version = ''
      })
      this.DisposeRules.forEach((item) => {
        item.checkAll = false
        item.checkAny = false
        item.anyRuleUuid = ''
        item.anyUuid = ''
        item.allRuleUuid = ''
        item.allUuid = ''
        item.filteringBasedDisposeAnyRules = item.validation[0].value
        item.filteringBasedDisposeAllRules = item.validation[0].value
        item.operationDisposeAnyRules = ''
        item.operationDisposeAllRules = ''
        item.filterValueDisposeAnyRules = ''
        item.filterValueDisposeAllRules = ''
        item.uuid = ''
        item.allVersion = ''
        item.anyVersion = ''
        item.ruleUuid = ''
        item.version = ''
      })
      this.disposeSettlementBill = {
        conditionType: 4,
        matchField: 'releaseDocRuleDataVo.settlementBill',
        matchOperator: '==',
        matchValue: 'true'
      }
      this.DisposeFilteringBased.ControlAnyChildrenCeditControl = [
        {
          value: this.$t('AutomaticRelease.common.creditLimitedDate'),
          id: 'releaseDocRuleDataVo.creditLimitedDate'
        },
        {
          value: this.$t('AutomaticRelease.common.creditLimitAmount'),
          id: 'releaseDocRuleDataVo.creditLimitAmount'
        },
        {
          value: this.$t('AutomaticRelease.common.creditLimitedETD'),
          id: 'releaseDocRuleDataVo.creditLimitedETD'
        }
      ]
      this.DisposeFilteringBased.ControlAllChildrenCeditControl = [
        {
          value: this.$t('AutomaticRelease.common.creditLimitedDate'),
          id: 'releaseDocRuleDataVo.creditLimitedDate'
        },
        {
          value: this.$t('AutomaticRelease.common.creditLimitAmount'),
          id: 'releaseDocRuleDataVo.creditLimitAmount'
        },
        {
          value: this.$t('AutomaticRelease.common.creditLimitedETD'),
          id: 'releaseDocRuleDataVo.creditLimitedETD'
        }
      ]
      this.ControlAnyChildrenRules = []
      this.ControlAllChildrenRules = []
      this.DisposeOperation = []
    }
  }
}
</script>
<style lang="scss">
#app{
  .dialogRule{
    .setStyle{
      color: #4283ff;
      .el-form-item__label{
        color: #4283ff !important;
      }
    }
    .businessTypes{
      display: inline-block;
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #DCDFE6;
      padding-left: 20px;
    }
    .spacing{
      padding: 0 40px 0 0;
      box-sizing: border-box;
      margin-top: 10px;
    }
    .newColumnRule{
      display: flex;
      margin-left:50px;
      .newColumn{
        display: flex;
        justify-content: content;
        align-items: center;
        margin-top:10px;
        .credit-control{
          width: 175px;
          margin-left:24px;
          display:flex;
        }
        cursor:pointer;
        .addIcon{
          width: 20px;
          height: 20px;
          background: #f2f6fc;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .selectCenterWidth{
          width: 80px;
          margin-left:10px;
        }
        .selectWidth{
          width: 175px;
          margin-left:10px;
        }
        .percentage{
          margin-left:95px !important;
        }
      }
    }
    .addIcon{
      width: 20px;
      height: 20px;
      background: #f2f6fc;
      display: flex;
      cursor:pointer;
      align-items: center;
      justify-content: center;
    }
    .action{
      margin: 15px 0 0 50px;
      .conditions{
        width: 85px;
        display: inline-block;
      }
    }
    .customer{
      margin:0 20px 0 20px;
      width:300px;
      .conditionsType{
        display:flex;
        align-items: center;
        margin:10px 0 0 20px;
        .title{
          width: 120px;
          margin-right:10px;
        }
      }
    }

    .conditionsTitle{
      margin: 10px 0 0 35px;
      display: inline-block;
    }
    .el-dialog{
      .el-dialog__body{
        padding: 0;
      }
      .app-main-inner-row{
        padding:0 !important;
        display:flex;
        justify-content: flex-start;
      }
    }
    .labelBoldStyle{
      .el-form-item__label{
        font-weight: bold !important;
      }
    }
  }
}
</style>
